<div class="text-align-center display-flex flex-direction-column">
  <h3 class="t-5@r color-void mb-4">Message Photo Rules</h3>
  <div class="t-8@r font-weight-500 color-red">No nudity or unacceptable images</div>
  <div class="t-8@r color-ash mb-6">
    @if (cost) {
      For {{ cost }} credits each photo, share your
    } @else {
      Message photos are where you can share
    }
    private moments with other members, but please follow the rules.
  </div>
  <button sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-green'" (click)="confirm()">Got it</button>
</div>
